import dayjs from 'dayjs'

import i18n from 'app/i18/i18'

/**
 * Вычисляет и форматирует оставшееся время до указанной даты
 * @param targetDate - Целевая дата (ISO строка)
 * @param targetTime - Целевое время (строка в формате HH:mm или HH:mm:ss)
 * @returns Отформатированная строка вида "2 дня 5 часов" или "18 часов" или undefined
 */
export const formatTimeRemaining = (
  targetDate?: string,
  targetTime?: string,
): string | undefined => {
  if (!targetDate) return undefined

  const now = dayjs()
  const parsedDate = dayjs(targetDate)

  if (!parsedDate.isValid()) {
    return undefined
  }

  let targetDateTime: dayjs.Dayjs
  if (targetTime) {
    const dateOnly = parsedDate.format('YYYY-MM-DD')
    const dateTimeString = `${dateOnly}T${targetTime}`
    targetDateTime = dayjs(dateTimeString)
  } else {
    targetDateTime = parsedDate
  }

  if (!targetDateTime.isValid()) {
    return undefined
  }

  const diff = targetDateTime.diff(now, 'millisecond')

  if (diff <= 0) {
    return undefined
  }

  const days = Math.floor(diff / (1000 * 60 * 60 * 24))
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))

  const parts: string[] = []

  if (days > 0) {
    parts.push(
      `${days} ${i18n.t('kyrgyzstan_block.time_units.day', { count: days })}`,
    )
  }

  if (hours > 0) {
    parts.push(
      `${hours} ${i18n.t('kyrgyzstan_block.time_units.hour', { count: hours })}`,
    )
  }

  if (minutes > 0 && days === 0) {
    parts.push(
      `${minutes} ${i18n.t('kyrgyzstan_block.time_units.minute', { count: minutes })}`,
    )
  }

  if (parts.length === 0) {
    return undefined
  }

  return parts.join(' ')
}
